import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class SettingGroupService {
  private settingGroupsURL = 'setting_groups';

  constructor(private httpClient: HttpClientService) {}

  getSettingGroups(data: any): Promise<any> {
    return this.httpClient.get(`${this.settingGroupsURL}.json`, data).catch(function () {});
  }

  createSettingGroup(data: any): Promise<any> {
    return this.httpClient.post(`${this.settingGroupsURL}.json`, data).catch(function () {});
  }

  updateSettingGroup(settingGroupId: number, data: any): Promise<any> {
    return this.httpClient.put(`${this.settingGroupsURL}/${settingGroupId}.json`, data).catch(function () {});
  }

  getSettingGroup(settingGroupId: number): Promise<any> {
    return this.httpClient.get(`${this.settingGroupsURL}/${settingGroupId}.json`).catch(function () {});
  }

  deleteSettingGroup(settingGroupId: number): Promise<any> {
    return this.httpClient.delete(`${this.settingGroupsURL}/${settingGroupId}.json`).catch(function () {});
  }
}
